<template>
  <transition name="fade">
    <div class="coupon-desc-mask" v-show="show" @click.self="handleClose">
      <div class="coupon-desc-panel">
        <!-- 头部：票券图标 + 标题 + 关闭按钮 -->
        <div class="panel-header">
          <img class="header-icon" :src="iconTicket" alt="" />
          <span class="header-title">{{ title }}</span>
          <span class="header-close" @click="handleClose">
            <Icon type="md-close" />
          </span>
        </div>
        <!-- 正文：后台配置的富文本 -->
        <div class="panel-body">
          <div v-if="descHtml" class="rich-content" v-html="descHtml"></div>
          <div v-else class="rich-empty">暂无说明</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import iconTicket from '@/assets/images/icon-coupon-ticket.png'

export default {
  name: 'CouponDescPopup',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '消费券说明',
    },
    // 如不传，则读取后台配置（设置 - 消费券相关 - 消费券说明）
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iconTicket,
    }
  },
  computed: {
    ...mapState(['setting']),
    descHtml() {
      return this.content || (this.setting && this.setting.c_coupon_desc) || ''
    },
  },
  watch: {
    show(val) {
      // 打开时若后台配置尚未加载，主动拉一次
      if (val && !this.descHtml) {
        this.$store.dispatch('getSetting')
      }
      val ? this.lockBodyScroll() : this.unlockBodyScroll()
    },
  },
  mounted() {
    // 初始即为打开态（如父级默认 true）也要锁滚动
    if (this.show) this.lockBodyScroll()
  },
  beforeDestroy() {
    this.unlockBodyScroll()
  },
  methods: {
    // 禁止滚动穿透：弹窗打开时锁住底层 body，关闭后还原（含滚动条占位补偿，避免页面横向跳动）
    lockBodyScroll() {
      if (this._scrollLocked) return
      this._prevOverflow = document.body.style.overflow
      this._prevPadRight = document.body.style.paddingRight
      const sbw = window.innerWidth - document.documentElement.clientWidth
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px'
      document.body.style.overflow = 'hidden'
      this._scrollLocked = true
    },
    unlockBodyScroll() {
      if (!this._scrollLocked) return
      document.body.style.overflow = this._prevOverflow
      document.body.style.paddingRight = this._prevPadRight
      this._scrollLocked = false
    },
    handleClose() {
      this.$emit('update:show', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.coupon-desc-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  overscroll-behavior: contain;
}
.coupon-desc-panel {
  width: 700px;
  max-width: calc(100vw - 40px);
  max-height: 70vh;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .panel-header {
    position: relative;
    flex-shrink: 0;
    min-height: 58px;
    padding: 13px 54px 13px 24px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    border-bottom: 1px solid #ebebeb;

    .header-icon {
      display: block;
      width: 32px;
      height: 32px;
      flex-shrink: 0;
    }
    .header-title {
      color: #0f1115;
      font-size: 20px;
      font-weight: 500;
      line-height: 1;
    }
    .header-close {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      color: #999999;
      font-size: 20px;
      line-height: 1;
      cursor: pointer;
      transition: color 0.2s;
      &:hover {
        color: #333333;
      }
    }
  }

  .panel-body {
    flex: 1;
    padding: 22px 24px;
    overflow-y: auto;
    overscroll-behavior: contain;

    .rich-empty {
      color: #999999;
      font-size: 14px;
      text-align: center;
      padding: 40px 0;
    }

    // 富文本正文样式（v-html 注入，需 ::v-deep 穿透）
    ::v-deep .rich-content {
      color: #333333;
      font-size: 14px;
      line-height: 1.8;
      word-break: break-word;

      p {
        margin: 0 0 10px;
      }
      h1,
      h2,
      h3,
      h4,
      h5 {
        margin: 16px 0 8px;
        color: #1a1a1a;
        font-weight: bold;
        line-height: 1.5;
      }
      h1 {
        font-size: 18px;
      }
      h2 {
        font-size: 17px;
      }
      h3 {
        font-size: 16px;
      }
      h4,
      h5 {
        font-size: 15px;
      }
      ul {
        list-style: disc;
        padding-left: 20px;
        margin: 0 0 10px;
      }
      ol {
        list-style: decimal;
        padding-left: 20px;
        margin: 0 0 10px;
      }
      li {
        margin-bottom: 4px;
      }
      strong,
      b {
        color: #1a1a1a;
      }
      a {
        color: #fa3d5a;
      }
      img {
        max-width: 100%;
      }
      table {
        border-collapse: collapse;
        width: 100%;
        th,
        td {
          border: 1px solid #e0e0e0;
          padding: 6px 10px;
        }
      }
    }
  }
}
</style>
